export default {
  theEmailIsNecessaryToSendYouTheTicketOrInvoices:
    "El email es necesario para enviarte los tickets o facturas.",
  enterTheAmountInKilograms: "Introduce la cantidad en Kilogramos",
  pleaseScanAValidQRCode: "Por favor, escanea un código QR válido.",
  doYouWantToReceiveYourTicketInvoiceInYour:
    "¿Quieres recibir tu ticket/factura en tu",
  whatDoYouWantToPay: "¿Qué quieres pagar?",
  noProductsLeftToPay: "No quedan productos por pagar",
  totalSelected: "Total seleccionado :",
  error: "Error !",
  discard: "Descartar",
  thereIsNoOrderForTheTable: "No hay ningún pedido para la mesa",
  tableOrder: "Pedido de la mesa",
  invitation: "INVITACIÓN",
  splitAccount: "dividir cuenta",
  byProducts: "por productos",
  cookingMeat: "COCCION DE LA CARNE",
  chooseYourDrink: "ESCOGE TU REFRESCO",
  chooseYourDishes: "Elige tus platos",
  selectTheQRCodeOfTheTable: "Selecciona el código QR de tu mesa",
  oopsSelectYourTable: "Ups, selecciona tu mesa",
  selectYourTable: "Selecciona tu mesa",
  wellCooked: "MUY HECHA",
  toThePoint: "AL PUNTO",
  underCooked: "POCO HECHA",
  pleaseDecreaseTheQuantityOfProducts:
    "Por favor, disminuya la cantidad de productos",
  divide: "Dividir",
  among: "Entre",
  amountToPay: "Cantidad a pagar",
  amount: "Importe",
  allTheProducts: "Todos los productos",
  pleaseEnterValidAmount:
    "Por favor, introduce un importe válido superior a 0,50€ o inferior a"
};
